import { render, staticRenderFns } from "./ActGroupBuyVip.vue?vue&type=template&id=2a911030&scoped=true"
import script from "./ActGroupBuyVip.vue?vue&type=script&lang=js"
export * from "./ActGroupBuyVip.vue?vue&type=script&lang=js"
import style0 from "./ActGroupBuyVip.vue?vue&type=style&index=0&id=2a911030&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a911030",
  null
  
)

export default component.exports